<template>
  <div>
    <div class="text-center display-1 font-weight-normal mb-6">
      Vamos começar preenchendo as informações básicas
    </div>
    <v-row id="importacao-titulo" class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="fs-titulo-importacao-dados"
            label="Título da importação"
            outlined
            :error-messages="errors"
            v-model="titulo"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row id="importacao-descricao" class="mx-auto">
      <v-col cols="12">
        <v-text-field
          id="fs-descricao-importacao-dados"
          label="Descrição (opcional)"
          outlined
          v-model="descricao"
        />
      </v-col>
    </v-row>
    <v-row id="importacao-tipo" class="mx-auto">
      <v-col cols="12">
        <v-select
          id="fs-tipo-importacao-dados"
          v-model="tipoImportacao"
          name="tipoImportacao"
          label="Tipo de Importação"
          :items="tiposImportacoes"
          outlined
          class="mb-0 pb-0"
          no-data-text="Nenhum tipo de importação disponível"
        />
      </v-col>
    </v-row>
    <!-- <v-row id="importacao-mes" class="mx-auto">
      <v-col cols="12" id="fs-mes-dados-importacao-dados">
        <input-month label="Mês dos dados" @monthSelected="monthSelected" />
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
  export default {
    name: "FirstTabContent",
    components: {
      // InputMonth: () => import("@/components/general/InputMonth.vue"),
    },
    data() {
      return {
        titulo: null,
        descricao: null,
        companyId: null,
        tipoImportacao: null,
        tiposImportacoes: [
          {
            value: "TEC",
            text: "Indicadores Técnicos",
          },
          {
            value: "SERV",
            text: "Qualidade Serviços",
          },
          {
            value: "REC",
            text: "Reclamação",
          },
        ],
        // mes: null,
      };
    },
    computed: {
      // data() {
      //   return this.mes ? `${this.mes}-01` : null;
      // },
    },
    watch: {
      titulo() {
        this.emitEventImportUpdated();
      },
      descricao() {
        this.emitEventImportUpdated();
      },
      companyId() {
        this.emitEventImportUpdated();
      },
      tipoImportacao() {
        this.emitEventImportUpdated();
      },
      // mes() {
      //   this.emitEventImportUpdated();
      // },
    },
    methods: {
      tipoSelected(tipoImportacao) {
        this.tipoImportacao = tipoImportacao;
      },
      companySelected(company) {
        this.companyId = company.id;
      },
      monthSelected(month) {
        this.mes = month;
      },
      emitEventImportUpdated() {
        this.$emit("import:updated", {
          titulo: this.titulo,
          descricao: this.descricao,
          companyId: this.companyId,
          tipoImportacao: this.tipoImportacao,
          // mes: this.mes,
          // data: this.data,
        });
      },
    },
  };
</script>
